import { COMPOSITION_GET_DATA_V3 } from '@revelio/data-access';

import { geoLevelsToSelectionListIds } from '../../../../../../../shared/selection-lists/utils/geoTaxonomyLevels';
import { FilterId } from '../../../../../filters/types/filters';
import { getEntKindForGeoOrRicsLevelId } from '../../../../../filters/utils/role-skill-ent-kind';
import type { IcicleTaxonomy } from './types';

export const geographyIcicleTaxonomy: IcicleTaxonomy = {
  segment: 'geography',
  filterId: FilterId.GEOGRAPHY,
  overlapping: false,
  query: COMPOSITION_GET_DATA_V3,
  breakdownLevelField: 'geo_breakdown_level',
  topNField: 'geography_top_n',
  tree: { kind: 'geography' },
  levelIds: (treeLevels, { geographySelectionListIds }) => {
    if (treeLevels.length === 0) return geographySelectionListIds;
    const levelIds = geoLevelsToSelectionListIds(treeLevels);
    return levelIds.length === treeLevels.length ? levelIds : null;
  },
  entKind: getEntKindForGeoOrRicsLevelId,
};
